import { useState, useEffect, useMemo } from 'react';
import { CONFIG_LIST_PAGE_SIZE } from '../utils/configurationTableUx';

/**
 * Paginates an in-memory list; shows footer only when totalCount > pageSize.
 */
export function useConfigurationListPagination(items, pageSize = CONFIG_LIST_PAGE_SIZE) {
  const [currentPage, setCurrentPage] = useState(1);
  const totalCount = items.length;
  const totalPages = Math.max(1, Math.ceil(totalCount / pageSize));

  useEffect(() => {
    setCurrentPage((p) => Math.min(p, totalPages));
  }, [totalPages]);

  const paginatedItems = useMemo(() => {
    const start = (currentPage - 1) * pageSize;
    return items.slice(start, start + pageSize);
  }, [items, currentPage, pageSize]);

  const rangeStart = totalCount === 0 ? 0 : (currentPage - 1) * pageSize + 1;
  const rangeEnd = Math.min(currentPage * pageSize, totalCount);
  const showPagination = totalCount > pageSize;

  return {
    currentPage,
    setCurrentPage,
    totalPages,
    paginatedItems,
    rangeStart,
    rangeEnd,
    totalCount,
    showPagination,
  };
}
